import {
    ButtonPrimary,
    Divider,
    IconBoxRegular,
    IconLocationMapRegular,
    IconTimeRegular,
    IconTruckRegular,
    IconMobileDeviceRegular,
    IconEmailRegular,
    IconUserAccountRegular,
    Text1,
    Text2,
    skinVars,
} from '@telefonica/mistica';
import { TrackingInfo, TrackingEvent } from '../../models/Orders';
import './index.scss';
import { TrackingStatusTag } from '../../pages/profile/orders/statusTags';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../pages/profile/orders/slotUtils';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';

export const TrackingInfoSection = ({ trackingInfo, orderId }: { trackingInfo: TrackingInfo; orderId: string }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const events: TrackingEvent[] = trackingInfo.events;

    const sendToNative = (url: string, description: string, err?: any) => {
        const storage = {
            events: events,
            url: trackingInfo.url,
        };

        localStorage.setItem('storage', JSON.stringify(storage));

        navigate(`${url}?id=${orderId}`, {
            state: {
                stateFeedback: description,
                err: err,
            },
        });
    };

    return (
        <div className='trackingInfo-component'>
            <div className='trackingInfo-component__title'>
                <IconTruckRegular size={24} color={skinVars.colors.textSecondary} />
                <div className='trackingInfo-component__title-text'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('trackingInfoTitle')}
                    </Text1>
                </div>
            </div>

            <div className='trackingInfo-component__content'>
                <div className='trackingInfo-component__content-calendar'>
                    {events?.length > 0 && (
                        <div className='trackingInfo-component__content-time'>
                            <div className='trackingInfo-component__content-calendar-info-icon'>
                                <IconTimeRegular size={24} color={skinVars.colors.brandHigh} />
                            </div>
                            <div className='trackingInfo-component__content-time-text'>
                                <Text2 regular>{capitalizeFirstLetter(events[events?.length - 1].description)}</Text2>
                            </div>
                        </div>
                    )}
                    {events?.length > 0 && (
                        <div className='trackingInfo-component__content-calendar-tag'>
                            {<TrackingStatusTag status={trackingInfo.status}></TrackingStatusTag>}
                        </div>
                    )}
                </div>

                {trackingInfo?.locationFullAddress && (
                    <div className='trackingInfo-component__content-calendar-info'>
                        <div className='trackingInfo-component__content-calendar-info-icon'>
                            <IconLocationMapRegular size={24} color={skinVars.colors.brandHigh} />
                        </div>
                        <div className='trackingInfo-component__content-calendar-info-text'>
                            <Text2 regular>{trackingInfo?.locationFullAddress}</Text2>
                        </div>
                    </div>
                )}

                {trackingInfo?.name && (
                    <div className='trackingInfo-component__content-personal'>
                        <div className='trackingInfo-component__content-calendar-info-icon'>
                            <IconUserAccountRegular size={24} color={skinVars.colors.brandHigh} />
                        </div>
                        <div className='trackingInfo-component__content-personal-text'>
                            <Text2 regular>{trackingInfo?.name}</Text2>
                        </div>
                    </div>
                )}

                {trackingInfo?.email && (
                    <div className='trackingInfo-component__content-personal'>
                        <div className='trackingInfo-component__content-calendar-info-icon'>
                            <IconEmailRegular size={24} color={skinVars.colors.brandHigh} />
                        </div>
                        <div className='trackingInfo-component__content-personal-text'>
                            <Text2 regular>{trackingInfo?.email}</Text2>
                        </div>
                    </div>
                )}

                {trackingInfo?.mobile && (
                    <div className='trackingInfo-component__content-personal'>
                        <div className='trackingInfo-component__content-calendar-info-icon'>
                            <IconMobileDeviceRegular size={24} color={skinVars.colors.brandHigh} />
                        </div>
                        <div className='trackingInfo-component__content-personal-text'>
                            <Text2 regular>{formatMobileNumber(trackingInfo?.mobile)}</Text2>
                        </div>
                    </div>
                )}

                {trackingInfo?.items && (
                    <div className='trackingInfo-component__content-equipament'>
                        <div className='trackingInfo-component__content-calendar-info-icon'>
                            <IconBoxRegular size={24} color={skinVars.colors.brandHigh} />
                        </div>
                        <div className='trackingInfo-component__content-equipament-text'>
                            {trackingInfo.items.map((text, index) => (
                                <Text2 regular key={index}>
                                    {index === trackingInfo.items.length - 1 ? `${text}` : `${text}, `}
                                </Text2>
                            ))}
                        </div>
                        {events?.length === 0 && (
                            <div className='trackingInfo-component__content-calendar-tag'>
                                {<TrackingStatusTag status={trackingInfo.status}></TrackingStatusTag>}
                            </div>
                        )}
                    </div>
                )}

                {trackingInfo?.observations && (
                    <div className='trackingInfo-component__content-observations'>
                        <div className='trackingInfo-component__content-observations-text'>
                            <Text2 medium color={skinVars.colors.textSecondary}>
                                {t('trackingInfoObservations')}
                            </Text2>
                        </div>
                        <div className='trackingInfo-component__content-equipament-text'>
                            <Text2 regular>{trackingInfo?.observations}</Text2>
                        </div>
                    </div>
                )}

                {events?.length > 0 && (
                    <div className='trackingInfo-component__content-buttons'>
                        <ButtonPrimary
                            small
                            onPress={() => {
                                sendToNative('/order-detail/time-line', 'time-line', '');
                            }}
                        >
                            {t('trackingInfoTextBtn')}
                        </ButtonPrimary>
                    </div>
                )}
                <div className='trackingInfo-component__content-divider'>
                    <Divider />
                </div>
            </div>
        </div>
    );
};
